import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import { notification } from 'ant-design-vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import CryptoJS from 'crypto-js'; //  使用CryptoJS库进行加密
import JSEncrypt from 'jsencrypt';

const baseURL = process.env.VUE_APP_API_BASE_URL
// 创建 axios 实例
const service = axios.create({
  baseURL: baseURL, // api base_url
  timeout: 300000 // 请求超时时间
})
export const pureAxios = axios.create({
  baseURL: baseURL, // api base_url
  timeout: 300000 // 请求超时时间
})
/**
 *
 * @returns 生成不重复的随机序列号  '60a2cd4faec2474ca6ee43aac3b0bc1d'
 * 32位  16进制
 */
function getUUID() {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  var uuid = "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}
// 定义AES加密函数
// console.log(getUUID(), 999)
let AESKey = getUUID()
// AES加密数据data
function aesEncrypt(data) {
  // 这样写的加密后在线工具可以正常解密，但是后台无法解密
  // return CryptoJS.AES.encrypt(JSON.stringify(data), 'sQPoC/1do9BZMkg8I5c09A==').toString();

  const _key = CryptoJS.enc.Utf8.parse(AESKey) //将秘钥转换成Utf8字节数组
  // const iv = CryptoJS.enc.Utf8.parse(key.substr(0, 16))
  //加密
  const encrypt = CryptoJS.AES.encrypt(JSON.stringify(data), _key, {
    // iv: iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypt.toString()
}

//定义RSA加密函数,，对AES秘钥加密
function rsaEncrypt(publicKey) {
  var encryptor = new JSEncrypt();
  // 假设你已经获取到了后端提供的公钥字符串（key是Base64编码的公钥）
  encryptor.setPublicKey(publicKey);

  //使用公钥加密
  var plaintext = AESKey;
  return encryptor.encrypt(plaintext);
}

// rsa解密
// export function decrypt(txt) {
//   const encryptor = new JSEncrypt()
//   encryptor.setPrivateKey('MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCwsfgTOWF3FIIlHZlf3CD+KrHhuwS/3zEwkwn3/fzr9C2Dlvy0dLoCAeVVtqFXTNH0YQsErt6ZUq7Cf9zb82abvsuEZ/4FKJoEgw8ZvGaN9tTRpD3WokalsJysTTJHcTLj9XqUrNXGn5w0T6bA1yJkuZ/JeCDfzmm17tactsiZPJ5zlAP0sL+2aRi17472W0dML6rIBdNXsqiz/bbpww7QgncjC/dCQKVn74ro4I7z4ZMs6QX2vcLd8UMD7ZBbcWzFuWc36OBcbQnu1r2+NMSar7E71g91Dc02u3eGhqaHFHiv/kXwcrF2v+bkGWuZ9VYWH+3rCdeE2QxFs1DDtcTVAgMBAAECggEAKU1AVoYIIUSa80AK9NxIngCu2bvUbWEnZ1pHbz9gWmsWJHcrlKbgP83fpHxvFC/xt7TjVXHmuGIaVX57yrIHXwpnGgkQ2HXYIovcAMEIG9EBiAtjJQODjgFNbf0Rbp+oLJ7Zy1znD2mJorSnntXqxS6aigZZcNcX4J32bmVPWHntt1OWm1a7ZyZKg6LEgaIhrjd5EBVEih89xoXEUC861A2I2zjxraqPPiEQ8n/uharUm4qZ1/l55HsheFKMxE+6dGmR0P7tmjcuxm1tVos9julbSq3VfojBg+9sW/SXWXJmLFnLKv4x+DrR5+P2P+WhtZ0uN5tzc1v7TFXtAhw39QKBgQDxkL3wRrxqKIoEF6YB5tkxo/CAYFgefDFQDymZQhX9ynRCCrz5JKbQaQkXpHQB8zp1u7lUF3Gm1FTx3l23k9cSyPf7j7tsT7vQsRAiyz5Wa6/bC5FHQAZ9hTbwdAL+oT0GKlyJysphvTmOehP+zGALsN+tIpUblKxBZG93r+twSwKBgQC7QOYe7WsOLqwiLCC9Xb1ar4fBNwbIq6XYbBWxkTlGHFNX7OEZ2Jzf/zZplP24pHNn3jDCBb6eDU2srvp2limnk06X8vb7NTzHk+b+4gqISLgs4tOX/Szgnmao33ZQrlj/3sDo1iwuQvqAz2TcWmk6xDCH04H371DCyVBkct+rXwKBgQCLSMX78Q1auJ071tbladH6CWj23JZynXFhlByMPcqoVz/JhJ+JmFSG/sk7VJt/NFuU3vTxQ8NISk3gWDL5UslED5TM/Ac5YJAOuMlxBnefJOB1EKpnxsb3QQR4iKvhXd7t2ycYXFFtIco6GLHGzNjkZMvT7IjFKmhYHC0ZednrGQKBgDombVAtapF87PevvHsSITuIRyA5dmHa7CXJavM5pg+fvEIRzdW47v6gwsUG/8PXTf9zgLDAF/H9L6HwtNceytC/bijByvE4FyfjRljg2WR5MLi/t/X7KXSXvEm1G4jym7DZ/A5SdGXpZuGZhjjn2sXlJy0HAdV8/BeBbPXEtrEBAoGAPBGCibHPIbChS0ZjfNpRJ5MjzhO2zmPxUbO/HAW9/+AHQZQROgH3rlUI1FfCBeTVcOYe5fw5w9BVjof6E8w86EAm3ReXxjwlq87xRuTKxbNcV37m2PF5gwOx1WSM6ZAXVXpMgj0rAe0ISb6xNPbFXZY3d/sBbIb5Eti57frXHQc=') // 设置私钥
//   return encryptor.decrypt(txt) // 对数据进行解密
// }
// console.log('解密1111', decrypt('rLtxzQauzOahv7SuzKh9D0m4BxZYYWEVaX+fusHcVbrkBKSEpAF21gZq/1cnvYjq7ZcfgKgap/sIz2Cx3QtegGaGwthbXM+pkFO/GS1ZmRtrEawP9J1ML1+z3hpGORo2YWt6M6obj+3yrRaTSS9BYRNhC7HSLFiPIcl5Q5eRIJ+h4/Wchbydm41Y2sxkHpSQ+ap1LNHFGvrNw9B1S1S6E4r2RO7Z1XwSQzjRXslcZgynIGk9sTzlNuxqcI5zSOC5zUvjf0Vv3EvdiXoPr5kQwf4uHTjkKS16q5mQixSpgsdJ/IGSiIjF3Hk0rRU6mtdQoufQSEPluOZqsSbvwezyDw=='))


var num = 0
const err = (error) => {


  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: '提示',
        description: data.message
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      num++
      if (num == 1) {
        notification.error({
          message: '提示',
          description: '登录超时，请重新登录'
        })
      }
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      } if (!token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  // console.log(config, 77777888888)
  if (['/auth/byPhonenumLogin', '/auth/lockLogin', '/auth/login'].includes(config.url)) {
    console.log('request4444444', localStorage)
    let PublicKey = ''
    if (!localStorage.getItem("PublicKey")) {
      Message({
        message: '未获取到公钥',
        type: 'error',
      })
      return
    } else {
      PublicKey = localStorage.getItem("PublicKey")
    }
    config.data = {
      data: aesEncrypt(config.data),
      aesKey: rsaEncrypt(PublicKey), //加密后的私钥
      publicKey: PublicKey
    };
  }
  return config
}, err)

pureAxios.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
